import api from "./api";
// 打卡任务

// 任务活动列表
export const taskActivityList = params => {
  return api("post", `/v1/management/task-clock/taskActivityList`, params);
};

// 下架任务活动
export const soldOutTaskActivity = params => {
  return api("get", `/v1/management/task-clock/soldOutTaskActivity/${params}`);
};

// 发布任务活动
export const publishTaskActivity = params => {
  return api("get", `/v1/management/task-clock/publishTaskActivity/${params}`);
};

// 任务活动详情
export const taskActivityDetails = params => {
  return api("get", `/v1/management/task-clock/taskActivityDetails/${params}`);
};
// 打卡任务列表
export const getTaskList = (objectType, objectId) => {
  // objectType : 1课程，2会员，3活动，4教练，5体测，6市场内容，7训练营，8系列课程商品管理，9单独打卡任务，10自定义任务
  return api("get", `/v1/management/task-clock/details/${objectType}/${objectId}`);
};

// 课程下拉框数据
export const taskCourseSelect = (params) => {
  return api("get", `/v1/management/task-clock/taskCourseSelect/${params}`);
};
// 活动下拉框数据
export const taskUaEventSelect = (params) => {
  return api("get", `/v1/management/task-clock/taskUaEventSelect/${params}`);
};

// 新增任务活动
export const postAddTaskActivity = (params) => {
  return api("post", `/v1/management/task-clock/createTaskActivity`, params);
};
// 编辑任务活动
export const postUpdateTaskActivity = (params) => {
  return api("post", `/v1/management/task-clock/updateTaskActivity`, params);
};
// 删除任务活动
export const deleteTaskActivity = (params) => {
  return api("get", `/v1/management/task-clock/deleteTaskActivity/${params}`);
};
// 新增任务打卡
export const createTaskClock = (params) => {
  return api("post", `/v1/management/task-clock/create`, params);
};
// 编辑任务打卡
export const updateTaskClock = (params) => {
  return api("post", `/v1/management/task-clock/update`, params);
};

// 跑步骑行下拉框数据
export const taskRunningSelect = (params) => {
  return api("get", `/v1/management/task-clock/taskRunningSelect/${params}`);
};

// 下载打卡记录
export const taskClockExportList = (params) => {
  return api("get", `/v1/management/task-clock/taskClockExportList/${params}`, {},
    {
      responseType: "blob",
    });
};

//抽奖
export const taskLottery = params => {
  return api("post", '/v1/management/task-clock/taskLottery', params);
}

//下载中奖名单
export const getTaskLotteryDownload = ({ objectType, objectId }) => {
  return api("get", `/v1/management/lottery/lotteryDownload/${objectType}/${objectId}`, {}, {
    responseType: 'blob'
  })
}

//查看中奖公示
export const taskClockShowLottery = (id) => {
  return api("get", `/v1/management/task-clock/showLottery/${id}`)
}

